import baseAPI from './axiosApi'

const api = {
    list: '/api-ir/hr/yearBonus/list',
    add: '/api-ir/hr/yearBonus/add',
    edit: '/api-ir/hr/yearBonus/edit',
    del: '/api-ir/hr/yearBonus/delete',
    export: '/api-ir/hr/yearBonus/export',
    assessDetail: '/api-ir/hr/assess/detail',
    schoolManagementCadres: '/api-ir/hr/assess/schoolManagementCadres',
}

export function list(data) {
    return baseAPI.axiosData(api.list, 'get', data)
}

export function add(data) {
    return baseAPI.axiosData(api.add, 'post', data)
}

export function edit(data) {
    return baseAPI.axiosData(api.edit, 'put', data)
}

export function del(data) {
    return baseAPI.axiosData(api.del, 'post', data)
}

export function exportFile(data) {
    return baseAPI.axiosData(api.export, 'get', data)
}

// 获取业绩津贴详情（用于加载工作量）
export function getAssessDetail(schoolYear, teacherId) {
    return baseAPI.axiosData(api.assessDetail + '/' + schoolYear + '/' + teacherId, 'get')
}

// 获取校管干部工号集合
export function getSchoolManagementCadres() {
    return baseAPI.axiosData(api.schoolManagementCadres, 'get')
}
